import styled from 'styled-components'
import { Swiper } from 'swiper/react'
import type { PromotionalBannerProps } from '@velasca/types'
import { MaxWidthContainer } from '@velasca/ui/max-width-container'

export const PromotionalBannerBackground = styled.div<{
  variant: PromotionalBannerProps['variant']
}>`
  background: ${({ theme, variant }) =>
    variant === 'semiTransparent'
      ? 'rgba(255, 255, 255, 0.3)'
      : theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
  position: relative;
  z-index: 1;
`
export const PromotionalBannerContainer = styled(MaxWidthContainer)<{
  showNavigationButtons: boolean
}>`
  display: flex;
  text-align: center;
  padding: ${({ showNavigationButtons }) =>
    !showNavigationButtons ? '0' : '0 1.5rem'};

  button {
    background: transparent;
    border: none;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:first-child {
      transform: rotate(180deg);
    }

    .pathArrow {
      stroke: ${({ theme }) => theme.colors.background};
    }
  }
`

export const StyledSwiper = styled(Swiper)`
  width: 100%;
`

export const PromotionalBannerSlide = styled.div`
  height: 41px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;

  & > div {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & * {
    font-size: 1.5rem;
  }

  & a {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`
